import { shipmentApiClient } from '../shipmentApiClient'

import { getTenantShipmentEndpoint } from './endpoint'
import type { GetTenantShipmentResponse } from './type'

export const getTenantShipment = async (
  tenantId: number,
  shipmentId: number
): Promise<GetTenantShipmentResponse> => {
  const res = await shipmentApiClient.get<GetTenantShipmentResponse>(
    getTenantShipmentEndpoint(tenantId, shipmentId)
  )
  return res.data
}
